import React from "react";
import ToolBar from "../../../components/toolbar/ToolBar";
import url from '../../../url'
import Select from "react-select";
import { Input, Label } from 'reactstrap'
import axios from "axios";
import { getFDate } from "../../../util/date";
import { store } from 'react-notifications-component';
import Loading from "../../../components/loading/Loading";
import ModernAlert from "../../../components/alert/ModernAlert";
import DraggableTable from "../../../components/draggable-table/DraggableTables";


class Ranking extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            drivers: { options: [], loading: false },
            licenseNumbers: { options: [], loadingD: false },
            groups: [],
            table: {},
            alert: { msg: '', type: '' },
            loading: false,
            filter: {
                startPeriod: "",
                endPeriod: "",
                startHour: "00:00",
                endHour: "23:59",
                groupName: [],
                idDrivers: [],
                idVehicles: [],
                vehicleGroup: false
            }

        }
    }




    componentDidMount() {
        this.getGroups();
        let setStyle = document.documentElement.style;
        setStyle.setProperty("--ant-table-fixed-columns-in-body", this.props.path.get === 'ranking' ? "200px" : '0');
        // console.log(this.props.pageTitle)
        // document.title = this.props.pageTitle || 'Telemetry'
        console.log(this.props.path)
        // getFDate()
    }
    getGroups = () => {
        axios
            .get(`${url}/v1/telemetria/admin/cache/groups/${this.props.token}`)
            .then(d => {
                // console.log(d.data);
                let groups = [];
                for (let i = 0; i < d.data.length; i++) {
                    groups.push({ value: d.data[i].name, label: d.data[i].name });
                }
                this.setState({ groups });
            })
            .catch(e => console.log(e.response));
    };

    getRancking = () => {
        this.setState({ loading: true, table: {}, alert: { msg: '', type: '' } });
        axios
            .post(`${url}/v1/telemetria/admin/report/${this.props.path.get}/${this.props.token}`, this.state.filter)
            .then(d => {
                console.log(d)
                if (d.data.data.length) {
                    this.setState({ table: d.data, loading: false });
                } else {
                    this.setState({
                        loading: false,
                        alert: {
                            type: "",
                            msg:
                                "Não foi possivel localizar resultados para o período selecionado."
                        }
                    });
                }
                //console.log(d.data);
            })
            .catch(e => {
                console.log(e)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    };
    exportRanking = () => {
        this.setState({ loading: true });
        const body = this.state.filter
        axios
            .request({
                url: `${url}/v1/telemetria/admin/report/${this.props.path.export}/${this.props.token}`,
                method: "POST",
                responseType: "blob", //important
                data: {
                    ...body,
                    columns: this.state.table.columns,
                    responseType: "blob"
                }
            })
            .then(({ data }) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute(
                    "download",
                    `${body.groupName.length > 0
                        ? "_" + body.groupName
                        : "_report"
                    }-${body.startPeriod}--${body.endPeriod}.xls`
                ); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.setState({ loading: false });
            })
            .catch(e => {
                console.log(e)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    };

    getColumns = c => {
        var columns = c
        c.forEach((d, i) => {
            if (d.isNumeric) {
                columns[i] = { ...d, sorter: (a, b) => this.getVal(a, d.dataIndex) - this.getVal(b, d.dataIndex) }
                // columns[i] = {...d, sorter: (a, b) => this.valueColum(a, d.key)}
            }
            if (this.fixedCols(d.title)) {
                columns[i] = { ...d, fixed: 'left', ellipsis: true, }
            }
            // if (d.title === 'POS.' || d.title === 'SCORE') {
            //     delete columns[i]
            // }
        });

        this.setState({
            table: {
                ...this.state.table,
                columns
            }
        });
    };

    fixedCols = key => {
        switch (key) {
            case 'MOTORISTA':
            case 'PLACA':
                return true
            default:
                break;
        }
    }

    getVal = (a, key) => {
        var val = Reflect.get(a, key)
        if (typeof val === "number") {
            return val
        } else {
            return val.replace(",", "").replace(".", "").replace("-", "0")
        }
    }

    renderToolbar = () => {
        return (
            <ToolBar>
                <div>
                    <label htmlFor="start-date" className='toolbar-label'>Inicio</label>
                    <input
                        id='start-date'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, startPeriod: i.target.value } })}
                        disabled={this.state.loading}
                        placeholder='Inicio'
                        max={getFDate()} />
                </div>
                <div>
                    <label htmlFor="start-hour" className='toolbar-label'>Hora</label>
                    <input
                        id="start-hour"
                        type="time"
                        className='form-control toolbar-time'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, startHour: i.target.value } })}
                        disabled={this.state.loading}
                    />
                </div>
                <div>

                    <label htmlFor="end-period" className='toolbar-label'>Fim</label>
                    <input
                        id='end-period'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, endPeriod: i.target.value } })}
                        disabled={this.state.loading || !this.state.filter.startPeriod}
                        min={this.state.filter.startPeriod}
                        max={getFDate()}
                    />
                </div>
                <div>
                    <label htmlFor="end-hour" className='toolbar-label'>Hora</label>
                    <input
                        id='end-hour'
                        type="time"
                        className='form-control toolbar-time'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, endHour: i.target.value } })}
                        disabled={this.state.loading || !this.state.filter.startPeriod}
                    />
                </div>
                <div>
                    <label htmlFor="drivers" className='toolbar-label'>Motoristas</label>
                    {/* Select Motoristas */}
                    <Select
                        inputId='drivers'
                        isLoading={this.state.drivers.loading}
                        className='toolbar-select'
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Motoristas"
                        noOptionsMessage={e => { return !e.inputValue ? 'Pesquise os motoristas!' : `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.drivers.options}
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, idDrivers: [] } })
                            }
                            else {
                                let idDrivers = []
                                i.forEach(d => idDrivers.push(d.value))
                                this.setState({ filter: { ...this.state.filter, idDrivers } })
                            }
                        }}
                        onInputChange={(i) => {
                            if (i.length > 2) {
                                this.setState({ drivers: { ...this.state.drivers, loading: true } });
                                axios
                                    .get(`${url}/v1/telemetria/admin/cache/drivers/${encodeURI(i)}/${this.props.token}`)
                                    .then(d => {
                                        let options = [];
                                        d.data.forEach(d => options.push({ label: d.driverName, value: d.driverId }))
                                        this.setState({ drivers: { options, loading: false } });
                                    })
                                    .catch(e => console.log(e.response));
                            }
                        }}
                        isDisabled={this.state.loading}
                    />
                </div>
                <div>
                    <label htmlFor="vehicles" className='toolbar-label'>Frotas</label>
                    {/* Select Frotas */}
                    <Select
                        inputId='vehicles'
                        isLoading={this.state.licenseNumbers.loadingD}
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Frotas"
                        className='toolbar-select'
                        noOptionsMessage={e => { return !e.inputValue ? 'Pesquise os motoristas!' : `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.licenseNumbers.options}
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, idVehicles: [] } })
                            }
                            else {
                                let idVehicles = []
                                i.forEach(d => idVehicles.push(d.value))
                                this.setState({ filter: { ...this.state.filter, idVehicles } })
                            }
                        }}
                        onInputChange={(i) => {
                            if (i.length > 2) {
                                this.setState({ licenseNumbers: { ...this.state.licenseNumbers, loading: true } });
                                axios
                                    .get(`${url}/v1/telemetria/admin/cache/vehicles/${encodeURI(i)}/${this.props.token}`)
                                    .then(d => {
                                        let options = [];
                                        d.data.forEach(d => options.push({ label: d.licenseNmbr, value: d.vehicleId }))
                                        this.setState({ licenseNumbers: { options, loading: false } });
                                    })
                                    .catch(e => console.log(e.response));
                            }
                        }}
                        isDisabled={this.state.loading}
                    />
                </div>
                <div>
                    <label htmlFor="groups" className='toolbar-label'>Grupos</label>

                    {/* Select Grupos */}
                    <Select
                        // isDisabled={this.state.loading}
                        // isLoading={this.state.collab.loading}
                        inputId='groups'
                        className='toolbar-select'
                        isMulti
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Grupo"
                        noOptionsMessage={e => { return `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.groups}
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, groupName: [] } })
                            }
                            else {
                                let groupName = []
                                i.forEach(d => groupName.push(d.value))
                                this.setState({ filter: { ...this.state.filter, groupName } })
                            }
                        }}
                        isClearable
                        isDisabled={this.state.loading} />
                    <Label check className='toolbar-label'>
                        <Input
                            type="checkbox"
                            onChange={() => this.setState({ filter: { ...this.state.filter, vehicleGroup: !this.state.filter.vehicleGroup } })}
                            checked={this.state.filter.vehicleGroup}
                            disabled={this.state.loading}
                        />{" "}
                        Agrupar por veículo
                    </Label>
                </div>
                <input
                    type="button"
                    value='Filtrar'
                    className='telemetry-button toolbar-button'
                    onClick={() => this.getRancking()}
                    disabled={!this.state.filter.startPeriod || !this.state.filter.endPeriod || this.state.loading}
                />

            </ToolBar>
        )
    }


    render() {
        return (
            <div>
                {this.renderToolbar()}

                {this.state.loading ? (
                    <div className='app-tool-center-loading '>
                        <Loading />
                    </div>
                ) : this.state.table.data ? (
                    <div>

                        <input
                            type="button"
                            value='Exportar Excel'
                            className='excel-button'
                            onClick={() => this.exportRanking()}
                            style={{ marginBottom: '20px' }}
                            disabled={this.state.loading}
                        />
                        <DraggableTable
                            path={this.props.path.get}
                            table={this.state.table}
                            getColumns={this.getColumns}
                        />
                    </div>
                ) : null}
                <div style={{ width: '440px', marginTop: '20px', alignSelf: 'center' }}>
                    <ModernAlert msg={this.state.alert.msg} color={this.state.alert.type} />
                </div>
            </div>
        )
    }

}

export default Ranking